if ( document.querySelectorAll('.video-container.reel').length ) {
    document.querySelectorAll('.video-container.reel').forEach(function(reel){
        reel.querySelector('img.video-teaser').addEventListener('click', function(){
            reel.querySelector('.uo-modal').style.zIndex = 1;
            reel.querySelector('.uo-modal').style.opacity = 1;
            reel.querySelector('.uo-modal').style.pointerEvents = 'all';
            reel.querySelector('video').play();
        });
        reel.querySelector('span.close').addEventListener('click', function(){
            reel.querySelector('.uo-modal').style.zIndex = -1;
            reel.querySelector('.uo-modal').style.opacity = 0;
            reel.querySelector('.uo-modal').style.pointerEvents = 'none';
            reel.querySelector('video').pause();
            reel.querySelector('video').currentTime = 0;
        });
    })
}

